import React, { useState } from 'react'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { useSelector } from 'react-redux'
import { State } from '../types/state'
import { useIsLargeView, useIsMobileView } from '../hooks/useIsMobileView'
import Button from '@mui/material/Button'
import { CSVLink } from 'react-csv'
import {
  generateStudentSelectionsReportData,
  generateSubjectSelectionsReportData
} from '../reports/utils'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { Role } from '../types/user'
import AddCommentDialog from './AddCommentDialog'

const UserSelections = (): JSX.Element => {
  const { studentsSelections, subjects, role } = useSelector(
    (state: State) => state.user
  )
  const isMobileView = useIsMobileView()
  const isLargeView = useIsLargeView()

  const [commentData, setCommentData] = useState({
    userId: null as number | null,
    isOpen: false,
    username: null as string | null
  })

  const SubjectsList: React.FC<{ id: number }> = ({ id }) => {
    const studentSelection = studentsSelections.find(s => s.id === id)!
    const subjectNames = studentSelection.selectedSubjects.map(
      s =>
        `${subjects.find(sub => sub.id === s.subjectId)?.name} - ${
          s.isHighLevel ? 'HL' : 'SL'
        }`
    )

    return (
      <div>
        {subjectNames.map((sn, index) =>
          (index + 1) % 3 === 0 ? (
            <>
              {sn},
              <br />
            </>
          ) : (
            <>{sn}, </>
          )
        )}
      </div>
    )
  }

  const AddCommentButton: React.FC<{ id: number }> = ({ id }) => {
    const userSelection = studentsSelections.find(s => s.id === id)!

    return (
      <Button
        variant='contained'
        style={{ fontSize: 11 }}
        onClick={() =>
          setCommentData({
            isOpen: true,
            userId: userSelection.id,
            username: userSelection.username
          })
        }
      >
        Add Comment
      </Button>
    )
  }

  const columns: GridColDef[] = [
    { field: 'username', headerName: 'Student', width: 120 },
    { field: 'firstName', headerName: 'First Name', width: 120 },
    { field: 'lastName', headerName: 'Last Name', width: 120 },
    {
      field: 'subjects',
      headerName: 'Choosen Subjects',
      width: 400,
      renderCell: params => <SubjectsList id={params.row.id} />
    },
    {
      field: 'commentButton',
      headerName: '',
      width: 120,
      renderCell: params => <AddCommentButton id={params.row.id} />
    }
  ]

  return (
    <div
      style={{
        height: isMobileView ? '75vh' : '60vh',
        width: isMobileView ? '80vw' : isLargeView ? '50vw' : '70vw',
        margin: 'auto',
        marginBottom: '5vw'
      }}
    >
      {commentData.isOpen && (
        <AddCommentDialog
          userId={commentData.userId!}
          username={commentData.username!}
          handleClose={() =>
            setCommentData({
              userId: null,
              username: null,
              isOpen: false
            })
          }
        />
      )}
      {(role === Role.ADMIN ||
        role === Role.SUPERADMIN ||
        role === Role.TEACHER) && (
        <>
          <CSVLink
            data={generateStudentSelectionsReportData(
              studentsSelections,
              subjects
            )}
            filename='students-report.csv'
            separator=';'
          >
            <Button
              variant='outlined'
              style={{
                margin: '1vw',
                // marginLeft: isMobileView ? '20vw' : '40vw',
                fontSize: isMobileView ? '12px' : undefined,
                width: isMobileView ? '25vw' : '15vw'
              }}
              endIcon={<FileDownloadIcon />}
              onClick={async () => {}}
            >
              Students Report
            </Button>
          </CSVLink>
          <CSVLink
            data={generateSubjectSelectionsReportData(
              studentsSelections,
              subjects,
              true
            )}
            filename='students-report.csv'
            separator=';'
          >
            <Button
              variant='outlined'
              style={{
                margin: '1vw',
                // marginLeft: isMobileView ? '20vw' : '40vw',
                fontSize: isMobileView ? '12px' : undefined,
                width: isMobileView ? '25vw' : '15vw'
              }}
              endIcon={<FileDownloadIcon />}
              onClick={async () => {}}
            >
              Subjects Report
            </Button>
          </CSVLink>
        </>
      )}
      {/* <DialogTitle>Students Selections</DialogTitle> */}
      <DataGrid
        disableRowSelectionOnClick
        rows={studentsSelections}
        columns={columns.filter(c =>
          c.field === 'commentButton'
            ? role === Role.ADMIN ||
              role === Role.SUPERADMIN ||
              role === Role.TEACHER
            : true
        )}
        checkboxSelection={false}
      />
    </div>
  )
}

export default UserSelections
